import anime from 'animejs';
import { isFunction } from '../functions';

export default class AutoScroll {
  constructor($element) {
    this.$element = $element;
    this.$element.style.marginTop = window.getComputedStyle(this.$element, null).getPropertyValue('padding-top');
    this.$element.style.paddingTop = '0';
    this.$element.style.marginBottom = window.getComputedStyle(this.$element, null).getPropertyValue('padding-bottom');
    this.$element.style.paddingBottom = '0';

    this.$element.style.overflowY = 'hidden';

    this.resize();

    this.picture = this.$element.querySelector('picture');
    this.bindImageLoaded = this.onImageLoaded.bind(this);
    this.picture.querySelector('img').addEventListener('load', this.bindImageLoaded);

  }

  onObservation(intersections) {
    const inters = intersections[0];
    if (!this.isScrolling && inters.isIntersecting) {
      this.scroll();
    } else if (!inters.isIntersecting) {
      this.stop();
    }
  }

  onImageLoaded() {
    this.picture.querySelector('img').removeEventListener('load', this.bindImageLoaded);
    this.init();
  }

  init() {
    this.animation = anime({
      targets: this.picture,
      translateY: - this.picture.offsetHeight + this.visibleHeight,
      direction: 'alternate',
      loop: true,
      easing: 'easeInOutQuad',
      duration: (this.picture.offsetHeight - this.visibleHeight) * 5,
      delay: 500,
      endDelay: 500,
    });

    if(isFunction(IntersectionObserver)) {
      if (!this.observer) {
        this.observer = new IntersectionObserver(this.onObservation.bind(this));
        this.observer.observe(this.$element);
      }
    } else {
      this.scroll();
    }
  }

  scroll() {
    this.isScrolling = true;
    if (this.animation) this.animation.play();
  }

  stop() {
    this.isScrolling = false;
    if (this.animation) this.animation.pause();
  }

  resize() {
    var maxHeight;
    if (this.$element.dataset.ratio) {
      maxHeight = this.$element.querySelector('picture').offsetWidth * parseFloat(this.$element.dataset.ratio);
    } else {
      var parent = this.$element.parentElement;
      var sibling = parent.nextElementSibling ? parent.nextElementSibling : parent.previousElementSibling;
      maxHeight = parseInt(sibling.querySelector('picture').offsetHeight);
    }
    var paddingTop = parseInt(window.getComputedStyle(this.$element, null).getPropertyValue('padding-top'));
    this.visibleHeight = maxHeight + paddingTop;
    this.$element.style.maxHeight = this.visibleHeight + 'px';

    if (this.animation) {
      this.picture.style.transform = 'translateY(0px)';
      anime.remove(this.picture);
      this.init();
    }
  }

}



// WEBPACK FOOTER //
// ./scripts/dom/AutoScroll.js